import React, { useState } from 'react'
import { Transition } from '@headlessui/react'
import { useSnapshot } from 'valtio'
import SidebarLayout from './SidebarLyout'
import CustomizerContext from '../CustomizerContext'
import { BsGear, BsX } from 'react-icons/bs';


const Layout = (props) => {

    const snap = useSnapshot(CustomizerContext)
    const [mobileMenuClose, setMobileMenuClose] = useState(true)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const changeMobileIcon = () => {
        if (mobileMenuClose && !mobileMenuOpen) setMobileMenuClose(!mobileMenuClose)
        if (!mobileMenuClose && mobileMenuOpen) setMobileMenuOpen(!mobileMenuOpen)
    }

    return (
        <div id="main-ui">

            <div className="absolute w-screen h-screen z-0">
                {props.children}
            </div>

                <Transition
                    show={snap.ui}
                    enter="transition ease-in-out duration-300 transform"
                    enterFrom="-translate-x-full"
                    enterTo="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leaveFrom="translate-x-0"
                    leaveTo="-translate-x-full"
                >

                    <div className="absolute z-20 pl-5 pr-5 pt-5 h-screen w-screen lg:w-1/2 xl:w-1/4">
                        <SidebarLayout />
                    </div>

                </Transition>
                
                <Transition
                    show={snap.mobileUi}
                    enter="transition ease-in-out duration-300 transform"
                    enterFrom="-translate-x-full"
                    enterTo="translate-x-0"
                >

                    <div onClick={() => { CustomizerContext.ui = !snap.ui; changeMobileIcon() }} className="absolute top-3 right-5 lg:right-auto lg:left-5 rounded h-25 w-25 absolute z-20 m-5 p-3 bg-black bg-opacity-25 visible  xl:invisible">



                        <Transition
                            show={mobileMenuOpen}
                            enter="transition-opacity duration-75"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition-opacity duration-150"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                            afterLeave={() => { setMobileMenuClose(true) }}
                        >
                            <BsGear color="white" size={36} />

                        </Transition>

                        <Transition
                            show={mobileMenuClose}
                            enter="transition-opacity duration-75"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition-opacity duration-150"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                            afterLeave={() => { setMobileMenuOpen(true) }}
                        >

                            <BsX color="white" size={36} />
                        </Transition>

                    </div>

                </Transition>
        </div>
    )
}

export default Layout